import axios from 'axios';
import React, { useState, useEffect } from 'react';

function LtiViewer({ iframeTitle, loginUrl, tokenAccessor, studioGroup, width = '100%', height = '100%', }) {
    const [ltiLaunchUrl, setLtiLaunchUrl] = useState();
    useEffect(() => {
        async function startLtiLaunch(loginUrl) {
            const accessToken = await tokenAccessor.tokenGetter();
            const res = await axios.get(loginUrl, {
                headers: { Authorization: `Bearer ${accessToken}`, studioGroup },
            });
            setLtiLaunchUrl(res.data.url);
        }
        startLtiLaunch(loginUrl);
    }, [loginUrl, studioGroup, tokenAccessor]);
    if (!ltiLaunchUrl)
        return null;
    return (React.createElement("iframe", { role: 'application', width: width, height: height, title: iframeTitle, src: ltiLaunchUrl, frameBorder: '0', allowFullScreen: true }));
}

export { LtiViewer };
